import { defineComponent as _defineComponent } from 'vue'
import SIcon from '@/components/SIcon.vue';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import DataProductQualityStatus from '@/components/quality-status/DataProductQualityStatus.vue';
import { type GetDataProductResponseDto } from '@/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataProductsDrawerTitle',
  props: {
  name: null,
  status: null,
  upstreamStatus: null
},
  setup(__props) {



return { __sfc: true,SIcon, SEllipsisTooltip, DataProductQualityStatus }
}

})